import { withInstall } from '../../utils'

import _TitleBar from './src/title-bar.vue'

export const SdTitleBar = withInstall(_TitleBar)
export default SdTitleBar

export * from './src/title-bar'
